import { render, staticRenderFns } from "./studentDashboard.vue?vue&type=template&id=319652c8"
import script from "./studentDashboard.vue?vue&type=script&lang=js"
export * from "./studentDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports